import { gql } from '@apollo/client';
import { CreatorFields } from '../fragments';

export const WorkspaceRowFragment = gql`
  fragment WorkspaceRowFields on WorkspaceRow {
    id
    analyses {
      id
      display
      queryType
      pref {
        chartPref
      }
    }
  }
`;

export const WorkspaceFieldsFragment = gql`
  fragment WorkspaceEntity on Workspace {
    id
    name
    description
    createdAt
    creator {
      ...CreatorFields
    }
    rows {
      ...WorkspaceRowFields
    }
  }
  ${CreatorFields}
  ${WorkspaceRowFragment}
`;
